import { Link } from '@tanstack/react-router';
import { analyticsConfigured, setConsent, useConsent } from '../lib/analytics.ts';

/**
 * Asks once whether we may use analytics, on every page until answered (the landing page included).
 * Nothing is loaded or sent before "Yes". Both answers are equally easy, and either can be changed later.
 */
export function ConsentBanner() {
  const consent = useConsent();
  if (!analyticsConfigured() || consent !== null) return null;
  return (
    <div role="region" aria-label="Analytics choice" className="fixed inset-x-0 bottom-0 z-50 p-3">
      <div className="panel mx-auto max-w-2xl space-y-3 shadow-lg">
        <p className="text-sm">
          May we count how people use Wynchester? It tells us which parts of the game to improve. We use PostHog, kept in the EU, with no
          adverts and no tracking on other sites. <Link to="/privacy" className="text-gilt underline">More in the privacy notice</Link>.
        </p>
        <div className="flex flex-wrap gap-3">
          <button type="button" className="btn" onClick={() => setConsent('yes')}>Yes, that’s fine</button>
          <button type="button" className="btn" onClick={() => setConsent('no')}>No thanks</button>
        </div>
      </div>
    </div>
  );
}

/** In every footer: ask again, so a "yes" can become a "no" (or the other way) at any time. */
export function CookieChoices() {
  const consent = useConsent();
  if (!analyticsConfigured()) return null;
  return (
    <button type="button" className="underline hover:text-ink" onClick={() => setConsent(null)} title={consent ? `Analytics: ${consent === 'yes' ? 'allowed' : 'refused'}` : undefined}>
      Analytics choice
    </button>
  );
}
